import type { EditorAPI } from '#packages/editorAPI';
import createCalendarWidget from './createCalendarWidget';

export default ({ editorAPI }: { editorAPI: EditorAPI }) =>
  createCalendarWidget({
    editorAPI,
  });
